import { booleanAttribute, Component, computed, inject, input, output } from '@angular/core';
import { DateOrTimestampToLocaleStringPipe } from '@pct-ng/common/pipe';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { fadeIn2XFastEnter, fadeInEnter } from '@pct-ng/animation';
import {
  type FileUploadConfig,
  type FileUploadResponse,
  FormatFileSizePipe,
  IsErrorFileUploadResponsePipe,
  IsRemovablePipe,
  ShowPreviewPipe,
} from '@pct-ng/feature-file-upload-native';
import { ResolveTranslateAbleTextPipe } from '@pct-ng/i18n';
import { IsImageFilePipe } from '@pct-ng/common/file';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatDivider } from '@angular/material/divider';
import { ImagePreviewService } from '@pct-ng/feature-image-native';
import { provideI18nScope } from '@pct-ng/transloco';
import { I18nProviderInjectionToken } from './i18n/scope';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'pct-feature-file-upload-material-file-list',
  imports: [
    DateOrTimestampToLocaleStringPipe,
    FormatFileSizePipe,
    MatCard,
    MatCardContent,
    MatIconButton,
    MatIcon,
    IsRemovablePipe,
    ResolveTranslateAbleTextPipe,
    ShowPreviewPipe,
    IsImageFilePipe,
    CustomMatSvgIconDirective,
    MatDivider,
    IsErrorFileUploadResponsePipe,
    TranslocoPipe,
  ],
  templateUrl: './material-file-list.component.html',
  animations: [fadeInEnter, fadeIn2XFastEnter],
  providers: [ImagePreviewService, provideI18nScope(I18nProviderInjectionToken)],
})
export class MaterialFileListComponent<T> {
  readonly #imagePreviewService = inject(ImagePreviewService);
  readonly #i18nScope: string = inject(I18nProviderInjectionToken);

  readonly i18nScope = input.required<string>();
  readonly hideCardShadow = input(false, { transform: booleanAttribute });
  readonly files = input.required<FileUploadResponse[]>();
  readonly loading = input.required<boolean>();
  readonly uploading = input.required<boolean>();
  readonly disabled = input.required<boolean>();
  readonly config = input.required<FileUploadConfig>();
  readonly remove = output<FileUploadResponse<T>>();

  protected readonly effectiveI18nScope = computed(
    (): string => this.i18nScope() ?? this.#i18nScope,
  );

  protected readonly effectiveDisabled = computed(() => this.disabled() || this.loading());

  protected onClickOpenPreview(file: File): void {
    this.#imagePreviewService.openImagePreview({ file });
  }

  protected onClickRemove(fileResponse: FileUploadResponse<T>): void {
    this.remove.emit(fileResponse);
  }
}
